import { graphql } from "@opensea/graphql"
import { itemUrlFragment } from "@/components/items/utils"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const useNotificationFragment = graphql(
  `
    fragment useNotification on Notification {
      ... on ItemBoughtNotification {
        item {
          imageUrl
          name
          ...itemUrl
        }
        price {
          ...TokenPrice
        }
        occurredAt
        isRead
      }
      ... on ItemSoldNotification {
        item {
          imageUrl
          name
          ...itemUrl
        }
        price {
          ...TokenPrice
        }
        occurredAt
        isRead
      }
      ... on BulkPurchaseNotification {
        representativeItem {
          imageUrl
        }
        numItems
        price {
          ...TokenPrice
        }
        occurredAt
        isRead
      }
      ... on BulkSaleNotification {
        representativeItem {
          imageUrl
        }
        numItems
        price {
          ...TokenPrice
        }
        occurredAt
        isRead
      }
      ... on RewardReadyToClaimNotification {
        quest {
          type
          tier
        }
        occurredAt
        isRead
      }
      ... on MintNotification {
        numItems
        collection {
          name
          imageUrl
        }
        occurredAt
        isRead
      }
      ... on DropStageReminderNotification {
        collection {
          name
          imageUrl
          slug
        }
        stageStartTime
        occurredAt
        isRead
      }
      ... on ShipmentReceivedNotification {
        shipmentId
        shipmentName
        shipmentDescription
        occurredAt
        isRead
      }
    }
  `,
  [TokenPriceFragment, itemUrlFragment],
)
